import type { RequestStatus } from "@suse-o11y/request-status";

import type { FullStackPack } from "~/models/dto";

export interface StackPacksState {
	stackPacksStatus: RequestStatus<Error, Array<FullStackPack>> | undefined;
}

export const initialStackPacksState: StackPacksState = {
	stackPacksStatus: undefined,
};
